import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "site-navigator" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "router-logo" }, null, -1)
const _hoisted_3 = { class: "router-minibar" }
const _hoisted_4 = { class: "router-link" }
const _hoisted_5 = { class: "router-link" }
const _hoisted_6 = { class: "router-link" }
const _hoisted_7 = { class: "router-link" }
const _hoisted_8 = { class: "router-settings" }
const _hoisted_9 = { class: "settings-language-container" }
const _hoisted_10 = { class: "settings-language-choice invisible" }
const _hoisted_11 = { class: "router-link" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "burger-menu-line" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { id: "navbarBurgerContainer" }
const _hoisted_15 = { class: "router-link-burger" }
const _hoisted_16 = { class: "router-link-burger" }
const _hoisted_17 = { class: "router-link-burger" }
const _hoisted_18 = { class: "router-link-burger" }
const _hoisted_19 = { class: "language-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "homeButtonLogo"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "navbar-0",
            to: "/contacts"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contacts")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "navbar-1",
            to: "/about"
          }, {
            default: _withCtx(() => [
              _createTextVNode("About")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "navbar-2",
            to: "/product"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Product")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            class: "navbar-3",
            to: "/gallery"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Gallery")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "settings-language languageButton",
            id: "currentLanguage",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleLanguage()))
          }, " EN "),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "languageButton",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage(0)))
            }, "EN"),
            _createElementVNode("button", {
              class: "languageButton",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage(1)))
            }, "GE")
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: "default-button-container navbar-4",
            to: "/buy"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Become A Member")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleClick())),
        id: "navbarBurgerMenu",
        class: "navbar-burger-menu"
      }, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "router-link-class navbar-0",
          to: "/contacts"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contacts")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, {
          class: "router-link-class navbar-1",
          to: "/about"
        }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, {
          class: "router-link-class navbar-2",
          to: "/product"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Product")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_router_link, {
          class: "router-link-class navbar-3",
          to: "/gallery"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Gallery")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "languageButton",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeLanguage(0)))
        }, "EN"),
        _createElementVNode("button", {
          class: "languageButton",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeLanguage(1)))
        }, "GE")
      ])
    ])
  ], 64))
}